import React, { createContext, useContext } from 'react';
var PricingContext = createContext(null);
var PricingProvider = function (_a) {
    var children = _a.children, shouldShowPricingBookPage = _a.shouldShowPricingBookPage;
    return (React.createElement(PricingContext.Provider, { value: { shouldShowPricingBookPage: shouldShowPricingBookPage } }, children));
};
var usePricingContext = function () {
    var context = useContext(PricingContext);
    if (!context) {
        throw new Error('usePricingContext must be used within PricingProvider');
    }
    return context;
};
export { PricingProvider, PricingContext, usePricingContext };
